import { defineMessages } from 'react-intl-next';

export default defineMessages({
	previewNotAvailable: {
		id: 'ai-mate.file-preview-modal.preview-not-available',
		defaultMessage: 'Preview not available for this file type',
		description: 'Message shown when file preview cannot be displayed',
	},
} as const);
